import axios from 'axios'
import { load_one, load_many } from '@/store/action-helpers'
import * as Types from '@/store/mutation-types'

// noinspection JSUnusedGlobalSymbols
export default {

    loadAllByVariantId: load_many('ratings', { params: { variantId: ':variantId' } }),

    loadOne: load_one('ratings/:id'),

    create({ commit }, { model }) {
        return axios.post('/api/v1/ratings', model).then(response => {
            commit(Types.SET_ONE, { content: response.data })
            return response.data
        })
    },

    update({ commit }, { model }) {
        return axios.put(`/api/v1/ratings/${model.id}`, model).then(response => {
            commit(Types.SET_ONE, { content: response.data })
            return response.data
        })
    },

}
